export enum EntityType {
    None = 'None',
    Quote = 'Quote',
    JobLead = 'JobLead',
    Order = 'Order',
    Customer = 'Customer',
    /**
     * Provider
     */
    Helper = 'Helper',
    ContactLead = 'ContactLead',
    Csr = 'Csr',
    InternalPhoneNumber = 'InternalPhoneNumber',
    Channel = 'Channel',
    ParentChannel = 'ParentChannel',
    Source = 'Source',
    Medium = 'Medium',
    BookingType = 'BookingType',
    CostType = 'CostType',
    Market = 'Market',
    HubspotWorkflow = 'HubspotWorkflow',
    PhoneExtension = 'PhoneExtension',
    Affiliate = 'Affiliate',
    EmailAddress = 'EmailAddress',
    PhoneNumber = 'PhoneNumber',
    Category = 'Category',
    ContentType = 'ContentType',
    Contact = 'Contact',
    JobContact = 'JobContact',
    User = 'User',
    CallLog = 'CallLog',
    /**
     * Crew Member
     */
    WorkerEmployee = 'WorkerEmployee',
    EmailMessage = 'EmailMessage',
    ComplianceDocument = 'ComplianceDocument',
    Sms = 'Sms',
    LineItemType = 'LineItemType',
    LineItemTypeContainer = 'LineItemTypeContainer',
    LineItemTypeEditorConfig = 'LineItemTypeEditorConfig',
    EquipmentItem = 'EquipmentItem',
    WorkerImage = 'WorkerImage',
    BankAccount = 'BankAccount',
    BankTransactionType = 'BankTransactionType',
    WorkerPublicInfo = 'WorkerPublicInfo',
    IssueType = 'IssueType',
    CsrGroup = 'CsrGroup',
    HubspotList = 'HubspotList',
    Transaction = 'Transaction',
    TransportOption = 'TransportOption',
    AffiliatePartner = 'AffiliatePartner',
    ScoreboardStats = 'ScoreboardStats',
    Claim = 'Claim',
    BankTransaction = 'BankTransaction',
    TransactionSettlement = 'TransactionSettlement',
    CallDisposition = 'CallDisposition',
    OrderCollection = 'OrderCollection',
    /**
     * Provider Application
     */
    HelperApplication = 'HelperApplication',
    TwilioTaskQueue = 'TwilioTaskQueue',
    CancellationReason = 'CancellationReason',
    PorchErpSyncLog = 'PorchErpSyncLog',
    UserAgent = 'UserAgent',
    Tag = 'Tag',
    LedgerAccount = 'LedgerAccount',
    TransientAuthToken = 'TransientAuthToken',
    QScoreFactor = 'QScoreFactor',
    BackgroundCheck = 'BackgroundCheck',
    DrugTest = 'DrugTest',
    PaymentBatch = 'PaymentBatch',
    WorkerLocationEquipment = 'WorkerLocationEquipment',
    WorkerLocationPolicy = 'WorkerLocationPolicy',
    HelperItem = 'HelperItem',
    FinancialInstitution = 'FinancialInstitution',
    LineItemTypeJobClassification = 'LineItemTypeJobClassification',
    LineItemTypePricingClassification = 'LineItemTypePricingClassification',
    FeatureFlag = 'FeatureFlag',
    Role = 'Role',
    SupportEmailAddress = 'SupportEmailAddress',
    SmsConversation = 'SmsConversation',
    Template = 'Template',
    Experiment = 'Experiment',
    ExperimentVariant = 'ExperimentVariant',
    BookingSubdomainLead = 'BookingSubdomainLead',
    DiscountCode = 'DiscountCode',
    DraftQuote = 'DraftQuote',
    Prospect = 'Prospect',
    UnifiedLead = 'UnifiedLead',
}

const entityTypeDescription = {
    None: 'None',
    Quote: 'Quote',
    JobLead: 'Job Lead',
    Order: 'Order',
    Customer: 'Customer',
    Helper: 'Provider',
    ContactLead: 'Contact Lead',
    Csr: 'Csr',
    InternalPhoneNumber: 'Internal Phone Number',
    Channel: 'Channel',
    ParentChannel: 'Parent Channel',
    Source: 'Source',
    Medium: 'Medium',
    BookingType: 'Booking Type',
    CostType: 'Cost Type',
    Market: 'Market',
    HubspotWorkflow: 'Hubspot Workflow',
    PhoneExtension: 'Phone Extension',
    Affiliate: 'Affiliate',
    EmailAddress: 'Email Address',
    PhoneNumber: 'Phone Number',
    Category: 'Category',
    ContentType: 'Content Type',
    Contact: 'Contact',
    JobContact: 'Job Contact',
    User: 'User',
    CallLog: 'Call Log',
    WorkerEmployee: 'Crew Member',
    EmailMessage: 'Email Message',
    ComplianceDocument: 'Compliance Document',
    Sms: 'Sms',
    LineItemType: 'Line Item Type',
    LineItemTypeContainer: 'Line Item Type Container',
    LineItemTypeEditorConfig: 'Line Item Type Editor Config',
    EquipmentItem: 'Equipment Item',
    WorkerImage: 'Worker Image',
    BankAccount: 'Bank Account',
    BankTransactionType: 'Bank Transaction Type',
    WorkerPublicInfo: 'Worker Public Info',
    IssueType: 'Issue Type',
    CsrGroup: 'Csr Group',
    HubspotList: 'Hubspot List',
    Transaction: 'Transaction',
    TransportOption: 'Transport Option',
    AffiliatePartner: 'Affiliate Partner',
    ScoreboardStats: 'Scoreboard Stats',
    Claim: 'Claim',
    BankTransaction: 'Bank Transaction',
    TransactionSettlement: 'Transaction Settlement',
    CallDisposition: 'Call Disposition',
    OrderCollection: 'Order Collection',
    HelperApplication: 'Provider Application',
    TwilioTaskQueue: 'Twilio Task Queue',
    CancellationReason: 'Cancellation Reason',
    PorchErpSyncLog: 'Porch Erp Sync Log',
    UserAgent: 'User Agent',
    Tag: 'Tag',
    LedgerAccount: 'Ledger Account',
    TransientAuthToken: 'Transient Auth Token',
    QScoreFactor: 'Q Score Factor',
    BackgroundCheck: 'Background Check',
    DrugTest: 'Drug Test',
    PaymentBatch: 'Payment Batch',
    WorkerLocationEquipment: 'Worker Location Equipment',
    WorkerLocationPolicy: 'Worker Location Policy',
    HelperItem: 'Helper Item',
    FinancialInstitution: 'Financial Institution',
    LineItemTypeJobClassification: 'Line Item Type Job Classification',
    LineItemTypePricingClassification: 'Line Item Type Pricing Classification',
    FeatureFlag: 'Feature Flag',
    Role: 'Role',
    SupportEmailAddress: 'Support Email Address',
    SmsConversation: 'Sms Conversation',
    Template: 'Template',
    Experiment: 'Experiment',
    ExperimentVariant: 'Experiment Variant',
    BookingSubdomainLead: 'Booking Subdomain Lead',
    DiscountCode: 'Discount Code',
    DraftQuote: 'Draft Quote',
    Prospect: 'Prospect',
    UnifiedLead: 'Unified Lead',
};

export const EntityTypeDescription = {
    ...entityTypeDescription,

    get: (value: EntityType | undefined | null): string | undefined => {
        if (typeof (value) === "string") {
            return entityTypeDescription[value];
        }
        if (value===null || value===undefined) {
            return undefined;
        }
        return entityTypeDescription[EntityType[value]  as keyof typeof entityTypeDescription];
    },
    all: [
        { value: 0, label: entityTypeDescription.None },
        { value: 1, label: entityTypeDescription.Quote },
        { value: 2, label: entityTypeDescription.JobLead },
        { value: 3, label: entityTypeDescription.Order },
        { value: 4, label: entityTypeDescription.Customer },
        { value: 5, label: entityTypeDescription.Helper },
        { value: 6, label: entityTypeDescription.ContactLead },
        { value: 7, label: entityTypeDescription.Csr },
        { value: 8, label: entityTypeDescription.InternalPhoneNumber },
        { value: 9, label: entityTypeDescription.Channel },
        { value: 10, label: entityTypeDescription.ParentChannel },
        { value: 11, label: entityTypeDescription.Source },
        { value: 12, label: entityTypeDescription.Medium },
        { value: 13, label: entityTypeDescription.BookingType },
        { value: 14, label: entityTypeDescription.CostType },
        { value: 15, label: entityTypeDescription.Market },
        { value: 16, label: entityTypeDescription.HubspotWorkflow },
        { value: 17, label: entityTypeDescription.PhoneExtension },
        { value: 18, label: entityTypeDescription.Affiliate },
        { value: 19, label: entityTypeDescription.EmailAddress },
        { value: 20, label: entityTypeDescription.PhoneNumber },
        { value: 21, label: entityTypeDescription.Category },
        { value: 22, label: entityTypeDescription.ContentType },
        { value: 23, label: entityTypeDescription.Contact },
        { value: 24, label: entityTypeDescription.JobContact },
        { value: 25, label: entityTypeDescription.User },
        { value: 26, label: entityTypeDescription.CallLog },
        { value: 27, label: entityTypeDescription.WorkerEmployee },
        { value: 28, label: entityTypeDescription.EmailMessage },
        { value: 29, label: entityTypeDescription.ComplianceDocument },
        { value: 30, label: entityTypeDescription.Sms },
        { value: 31, label: entityTypeDescription.LineItemType },
        { value: 32, label: entityTypeDescription.LineItemTypeContainer },
        { value: 33, label: entityTypeDescription.LineItemTypeEditorConfig },
        { value: 34, label: entityTypeDescription.EquipmentItem },
        { value: 35, label: entityTypeDescription.WorkerImage },
        { value: 36, label: entityTypeDescription.BankAccount },
        { value: 37, label: entityTypeDescription.BankTransactionType },
        { value: 38, label: entityTypeDescription.WorkerPublicInfo },
        { value: 39, label: entityTypeDescription.IssueType },
        { value: 40, label: entityTypeDescription.CsrGroup },
        { value: 41, label: entityTypeDescription.HubspotList },
        { value: 42, label: entityTypeDescription.Transaction },
        { value: 43, label: entityTypeDescription.TransportOption },
        { value: 44, label: entityTypeDescription.AffiliatePartner },
        { value: 45, label: entityTypeDescription.ScoreboardStats },
        { value: 46, label: entityTypeDescription.Claim },
        { value: 47, label: entityTypeDescription.BankTransaction },
        { value: 48, label: entityTypeDescription.TransactionSettlement },
        { value: 49, label: entityTypeDescription.CallDisposition },
        { value: 50, label: entityTypeDescription.OrderCollection },
        { value: 51, label: entityTypeDescription.HelperApplication },
        { value: 52, label: entityTypeDescription.TwilioTaskQueue },
        { value: 53, label: entityTypeDescription.CancellationReason },
        { value: 54, label: entityTypeDescription.PorchErpSyncLog },
        { value: 55, label: entityTypeDescription.UserAgent },
        { value: 56, label: entityTypeDescription.Tag },
        { value: 57, label: entityTypeDescription.LedgerAccount },
        { value: 58, label: entityTypeDescription.TransientAuthToken },
        { value: 59, label: entityTypeDescription.QScoreFactor },
        { value: 60, label: entityTypeDescription.BackgroundCheck },
        { value: 61, label: entityTypeDescription.DrugTest },
        { value: 62, label: entityTypeDescription.PaymentBatch },
        { value: 63, label: entityTypeDescription.WorkerLocationEquipment },
        { value: 64, label: entityTypeDescription.WorkerLocationPolicy },
        { value: 65, label: entityTypeDescription.HelperItem },
        { value: 66, label: entityTypeDescription.FinancialInstitution },
        { value: 67, label: entityTypeDescription.LineItemTypeJobClassification },
        { value: 68, label: entityTypeDescription.LineItemTypePricingClassification },
        { value: 69, label: entityTypeDescription.FeatureFlag },
        { value: 70, label: entityTypeDescription.Role },
        { value: 71, label: entityTypeDescription.SupportEmailAddress },
        { value: 72, label: entityTypeDescription.SmsConversation },
        { value: 73, label: entityTypeDescription.Template },
        { value: 74, label: entityTypeDescription.Experiment },
        { value: 75, label: entityTypeDescription.ExperimentVariant },
        { value: 76, label: entityTypeDescription.BookingSubdomainLead },
        { value: 77, label: entityTypeDescription.DiscountCode },
        { value: 78, label: entityTypeDescription.DraftQuote },
        { value: 79, label: entityTypeDescription.Prospect },
        { value: 80, label: entityTypeDescription.UnifiedLead },
    ] as ReadonlyArray<{label: string, value: number}>
};
